import styled from 'styled-components';
import { media } from '../../../constants/media/media';
import theme from '../../../constants/theme';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';

export const FormWrapper = styled.div`
	background-color: white;
	padding: 3rem;
	max-height: 100%;
	max-width: 100%;
	overflow: auto;

	@media screen and (max-width: 60rem) {
		min-width: 0;
	}

	input {
		margin-bottom: 1rem;
	}

	button {
		float: right;
		margin-top: 3rem;
	}

	label {
		color: ${theme.colors.black};
	}

	${({ large }) =>
		large &&
		`
		height: 80vh;
	`}

	${media.mobileOnly`
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;

        button { width: 100%; }
    `}

	${({ red }) =>
		red &&
		`
        background-color: ${theme.colors.primary};
        color: white;
	    padding: 2rem;
	    min-width: 0;

	    button {
            float: left;
	        margin: 1rem 1rem 0 0;
	        :last-child { margin-right: 0; }
	    }
    `}
`;
export const Wrapper = styled.div`
	${media.desktopSmall`
		display: flex;

		> div {
			width: 50%;
		}
	`}

	> div:last-child {
		form {
			width: 100%;
			> div {
				> div {
					> div {
						width: 100%;
					}
				}
			}
		}
	}
`;

export const Image = styled(DynamicRspImage)`
	${media.desktopSmall`
		max-width: 50%;
	`}
`;
